const SUPER_ADMIN_ALLOWLIST = ['jwade', 'justin@jz.io'];

export const isSuperAdmin = (user: { username?: string; email?: string } | null): boolean => {
  if (!user) return false;
  return (
    SUPER_ADMIN_ALLOWLIST.includes(user.username || '') ||
    SUPER_ADMIN_ALLOWLIST.includes(user.email || '')
  );
};
